import React, { FC } from 'react';
import { TextInput } from '../../../../shared/components/inputs';
import { Button } from '../../../../shared/components/button';
import {
  CardContainer,
  CardLabelHeader,
} from '../../../../shared/components/card';
import { NavigationLink } from '../../../../shared/components/utility';
import { ReduxStatus } from '../../../../shared/types';

interface OnboardingTemplteProps {
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  isLoading: ReduxStatus;
}

const OnboardingTemplate: FC<OnboardingTemplteProps> = ({
  onChange,
  onSubmit,
  isLoading,
}) => {
  return (
    <CardContainer
      stripPadding={false}
      header={<CardLabelHeader headerHeight='AUTO' label='Log In' />}
    >
      <form onSubmit={onSubmit}>
        <TextInput
          classes={['mb-10']}
          label='User Credentials'
          name='credential'
          placeholder='Username or Email Address'
          onChange={onChange}
          tabIndex={0}
        />
        <TextInput
          classes={['mb-10']}
          label='Password'
          type='password'
          name='password'
          placeholder='Password'
          onChange={onChange}
          tabIndex={0}
        >
          <NavigationLink
            dest='/reset-request'
            label='Forgot Password?'
            tabIndex={-1}
          />
        </TextInput>
        <Button
          isLoading={isLoading === 'loading'}
          theme='PRIMARY'
          label='Login'
          onClick={() => {}}
          tabIndex={0}
        ></Button>
      </form>
    </CardContainer>
  );
};

export default OnboardingTemplate;
